__turbopack_context__.v({
  "className": "lexend_d7a5a97b-module__pzQ2HG__className",
});
